export default "__VITE_ASSET__C$Kpy_sJ__"